import { render, staticRenderFns } from "./PickAnswerV2.vue?vue&type=template&id=5faca27f&"
import script from "./PickAnswerV2.vue?vue&type=script&lang=js&"
export * from "./PickAnswerV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports